<eventq-dialog-popover
  [open]="open()"
  title="Park Event Duration"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="confirmDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="park-event-popover__options" role="listbox" aria-label="Park duration">
    @for (option of durationOptions(); track option.minutes) {
      <button
        type="button"
        class="park-event-popover__option"
        role="option"
        [class.park-event-popover__option--selected]="option.minutes === selectedDurationMinutes()"
        [attr.aria-selected]="option.minutes === selectedDurationMinutes()"
        (click)="onSelect(option.minutes)"
      >
        {{ option.label }}
      </button>
    }
  </div>
</eventq-dialog-popover>
